import { ReactComponent as FlagIcon } from "./svg/sk-flag.svg";
import "../flag-icon.scss";

export const SKFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
